import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import BudgetReallocationForm, {
    BudgetReallocationRequestFormProps
} from "../../../pages/administration/allocation/components/reallocation/ReallocationForm";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, BudgetReallocationRequestFormProps {
}

type Props = OwnProps;

// @ts-ignore
const BudgetReallocationRequestModal = NiceModal.create<Props>(({reallocation, onClose, header}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <BudgetReallocationForm reallocation={reallocation}/>
        </SlideOver>
    )
})

export default BudgetReallocationRequestModal;
